import _slicedToArray from "/Users/jfriend/code/scaletoy/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { note, transpose as transpose$1, distance as distance$1 } from '@tonaljs/core';

var fillStr = function fillStr(character, times) {
  return Array(times + 1).join(character);
};

var REGEX = /^(_{1,}|=|\^{1,}|)([abcdefgABCDEFG])([,']*)$/;

function tokenize(str) {
  var m = REGEX.exec(str);

  if (!m) {
    return ["", "", ""];
  }

  return [m[1], m[2], m[3]];
}
/**
 * Convert a (string) note in ABC notation into a (string) note in scientific notation
 *
 * @example
 * abcToScientificNotation("c") // => "C5"
 */


function abcToScientificNotation(str) {
  var _tokenize = tokenize(str),
      _tokenize2 = _slicedToArray(_tokenize, 3),
      acc = _tokenize2[0],
      letter = _tokenize2[1],
      oct = _tokenize2[2];

  if (letter === "") {
    return "";
  }

  var o = 4;

  for (var i = 0; i < oct.length; i++) {
    o += oct.charAt(i) === "," ? -1 : 1;
  }

  var a = acc[0] === "_" ? acc.replace(/_/g, "b") : acc[0] === "^" ? acc.replace(/\^/g, "#") : "";
  return letter.charCodeAt(0) > 96 ? letter.toUpperCase() + a + (o + 1) : letter + a + o;
}
/**
 * Convert a (string) note in scientific notation into a (string) note in ABC notation
 *
 * @example
 * scientificToAbcNotation("C#4") // => "^C"
 */


function scientificToAbcNotation(str) {
  var n = note(str);

  if (n.empty || !n.oct) {
    return "";
  }

  var letter = n.letter,
      acc = n.acc,
      oct = n.oct;
  var a = acc[0] === "b" ? acc.replace(/b/g, "_") : acc.replace(/#/g, "^");
  var l = oct > 4 ? letter.toLowerCase() : letter;
  var o = oct === 5 ? "" : oct > 4 ? fillStr("'", oct - 5) : fillStr(",", 4 - oct);
  return a + l + o;
}

function transpose(note, interval) {
  return scientificToAbcNotation(transpose$1(abcToScientificNotation(note), interval));
}

function distance(from, to) {
  return distance$1(abcToScientificNotation(from), abcToScientificNotation(to));
}

var index = {
  abcToScientificNotation: abcToScientificNotation,
  scientificToAbcNotation: scientificToAbcNotation,
  tokenize: tokenize,
  transpose: transpose,
  distance: distance
};
export default index;
export { abcToScientificNotation, distance, scientificToAbcNotation, tokenize, transpose };